export const CLIENT_CONFIG_SUCCESS = "CLIENT_CONFIG_SUCCESS";
export const CLIENT_CONFIG_LOADING = "CLIENT_CONFIG_LOADING";
